import cx from "classnames";
import { Button, Flex } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { ComponentProps } from "react";
import { BOX_ACTIONS, TBoxActions } from "@coreapp/constants";

type Props = {
  showRevert: boolean;
  onSave: () => void;
  onClose: () => void;
  dataTestIdPrefix?: string;
  onRevert?: () => void;
  buttonProps?: {
    [key: string]: any;
  };
  customClass?: string;
  flexProps?: {
    [key: string]: any;
  };
  primaryBtnProps?: ComponentProps<typeof Button>;
  action?: TBoxActions;
  allowSave?: boolean;
};

export const RecordEditorFooter = (props: Props) => {
  const dataTestIdPrefix = props?.dataTestIdPrefix || "record-editor-";
  const buttonSize = props?.buttonProps?.size ?? "medium";
  const allowSave = props?.allowSave ?? true;

  return (
    <Flex
      justifyContent={"space-between"}
      className={cx("oc-custom-overlay-footer", "oc-footer-button-container", props?.customClass)}
      alignItems={"center"}
      width={"100%"}
      {...props?.flexProps}
    >
      {props?.showRevert && (
        <Button
          dataTestId={`${dataTestIdPrefix}action-revert`}
          onClick={props?.onRevert}
          modifier="secondary"
          size={buttonSize}
          className={"oc-footer-button"}
          {...props?.buttonProps}
        >
          {appstr("Revert")}
        </Button>
      )}
      <Flex gap={"8px"} className={"oc-right-justify"}>
        <Button
          dataTestId={`${dataTestIdPrefix}action-cancel`}
          onClick={props.onClose}
          modifier="tertiary"
          size={buttonSize}
          className={cx("oc-footer-button")}
          {...props?.buttonProps}
        >
          {appstr("Cancel")}
        </Button>
        <Button
          dataTestId={`${dataTestIdPrefix}action-save`}
          onClick={props.onSave}
          modifier="primary"
          size={buttonSize}
          className={cx("oc-footer-button")}
          disabled={!allowSave}
          {...props?.buttonProps}
          {...props?.primaryBtnProps}
        >
          {appstr(props.action === BOX_ACTIONS.REOPEN ? "Reopen" : "Save")}
        </Button>
      </Flex>
    </Flex>
  );
};
